import {get, post} from '../components/api'

export const getMeetingRoomPrice =  (meetingroomId, hour, start_date, time, use_credit, credit_type, code, requestWht) => {
    const data =  post(`/admin/meeting_rooms/get_booking_order_summary`,  {
      meeting_room_id: meetingroomId, hour, start_date, time, use_credit, credit_type, code, request_for_wht: requestWht
    })

    return data
}
